// extracted by mini-css-extract-plugin
module.exports = {"button":"guest_button__1W7XT","deleteIcon":"guest_deleteIcon__3GWpe"};